<template>
	<div class="">

		<search
			:program="program"
			:search="item_search"
			:option="item_search_option"

			@click="getSearch"
			@toItem="toItem"
		>
		</search>

		<div class="mt-10">
			<button
				:class="item_search.b_category == '' ? 'btn-primary' : 'btn-default'"
				@click="item_search.b_category = ''; getData()"
			>전체</button>
			<button
				v-for="category in items_category"
				:key="'cate_' + category"
				:class="category == item_search.b_category ? 'btn-primary' : 'btn-default'"
				@click="item_search.b_category = category; getData()"
			>{{ category }}</button>
		</div>

		<template
			v-if="items.length > 0"
		>
			<table class="table-outline hide-m mt-10">
				<colgroup>
					<col width="80px" />
					<col width="100px" />
					<col width="auto" />
				</colgroup>
				<thead>
				<tr>
					<th>No</th>
					<th>구분</th>
					<th>제목</th>
				</tr>
				</thead>
				<tbody>
				<template

					v-for="(item, index) in list_items"
				>
					<tr
						@click="toDetail(item)"
						:key="'item_' + index"

					>
						<td :rowspan="item.is_on ? 2 : 1">{{ item.no }}</td>
						<td :rowspan="item.is_on ? 2 : 1">{{ item.b_category }}</td>
						<td class="td-left " :class="{'bg-base': item.is_on}">
							<div class="justify-space-between items-center">
								<div class="font-weight-bold"><span class="color-red font-weight-bold">Q.</span> {{ item.b_title }}</div>
								<v-icon v-if="item.is_on">mdi mdi-chevron-up</v-icon>
								<v-icon v-else>mdi mdi-chevron-down</v-icon>
							</div>
						</td>
					</tr>
					<tr
						v-if="item.is_on"
						:key="'item_answer' + index"
					>
						<td class="td-left">
							<Viewer
								v-if="item.b_contents"
								:initialValue="'A. ' + item.b_contents"
								class="pa-10"
							/>
						</td>
					</tr>
				</template>
				</tbody>
			</table>

			<ul class="hide-pc mt-10 top-line">
				<li
					v-for="item in list_items"
					:key="'item_' + item.uid"
					class=" "
				>
					<div
						class="pa-10 justify-space-between items-center under-line"
						:class="item_content != item.uid ? 'bg-white' : 'bg-base'"
						@click="item_content != item.uid ? item_content = item.uid : item_content = null"
					>
						<span><span :class="item.is_answer_color">{{ item.is_answer_name }}</span>. {{ item.b_title }}</span>
						<v-icon
							v-if="item_content != item.uid"
						>mdi mdi-menu-down</v-icon>
						<v-icon
							v-else
						>mdi mdi-menu-up</v-icon>
					</div>
					<div
						v-if="item_content == item.uid"
						class="under-line"
					>
						<Viewer
							v-if="item.b_contents"
							:initialValue="'A. ' + item.b_contents"
							class="pa-10"
						/>
					</div>
				</li>
			</ul>

			<Pagination
				:program="program"
				:align="'center'"
				:options="item_search"

				@click="getSearch"

				class="mt-auto pa-10"
			></Pagination>
		</template>
		<Empty
			v-else
			class="mt-10"
		>
		</Empty>
	</div>
</template>

<script>

import '@toast-ui/editor/dist/toastui-editor-viewer.css';
import { Viewer } from "@toast-ui/vue-editor";
import Pagination from "../../components/Pagination";
import Search from "../Layout/Search";
import Empty from "../Layout/Empty";

export default {
	name: 'FaqList'
	,props: ['user', 'is_mobile']
	,components: {Empty, Search, Pagination, Viewer}
	,data: function() {
		return {
			program: {
				name: '자주하는질문'
				, from: 'Index'
				, top: false
				, title: true
				, bottom: true
				, is_container: true
			}
			,item_search:{
				b_code: this.$route.params.b_code
				, page: 1
				, list_cnt: 10
				, tCnt: 0
				, search_type: 'b_title'
				, search_value: ''
				, b_category: ''
			}
			, item_search_option: {
				is_cnt: true
				, search_type: [{ column: 'b_title', name: '제목'}]
			}
			,items: [

			]
			,item_content: null
			, board_category: ''
		}
	}

	,computed: {
		list_items: function(){
			return this.items.filter( (item, index) => {
				item.no = this.item_search.tCnt - (this.item_search.page * this.item_search.list_cnt - this.item_search.list_cnt) - index
				if(item.b_answer){
					item.is_answer_color = 'color-red font-weight-bold'
					item.is_answer_name = 'Q'
				}else{
					item.is_answer_color = 'color-red font-weight-bold'
					item.is_answer_name = 'Q'
				}
				return item
			})
		}
		, items_category: function(){
			let t = []

			t = this.board_category.split("\r\n")

			return t
		}
	}
	,methods: {
		getData: async function(){
			try{
				this.$bus.$emit('on', true)
				const result = await this.$request.init({
					method: 'get'
					,url: 'board/getBbsList'
					,data: this.item_search
				})
				if(result.success){
					this.items = result.data.result
					this.board_category = result.data.category
					this.$set(this.item_search, 'tCnt', result.data.tCnt)
					this.$bus.$emit('notify', { type: 'success', message: result.message })
				}else{
					this.$bus.$emit('notify', { type: 'error', message: result.message })
				}
			}catch (e) {
				console.log(e)
			}finally {
				this.$bus.$emit('on', false)
			}
		}
		, getSearch: function(page){
			if(page){
				this.item_search.page = page
			}
			this.getData()
		}
		,toItem: function(){
			this.$bus.$emit('to', { name: 'BbsItem', params: { b_code: this.item_search.b_code }})
		}
		, toDetail: function(item){
			this.$set(item, 'is_on', !item.is_on)
		}
	}
	,created() {
		console.log('in faqlist ')

		if(this.is_mobile){
			this.program.not_top = true
		}
		this.$bus.$emit('onLoad', this.program)
		this.getData()
	}
}
</script>